module.exports = __webpack_public_path__ + "2-lined-87d3ed2b63e121b4101468c81240c0a9.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/lined/2-lined.svg
// module id = 130
// module chunks = 0